export { default as LocalForage } from './LocalForage';
